import { Head, Banner, Contact, News } from "../components/Project";
import { Grid, Space, Table } from "../components/Layout";
import { Title, Texts, Media } from "../components/Object";

const Company = () => {
  return(
    <>
      <Head type="noimage" slug="company"></Head>
      <div className="p-box__wrap--about" data-state="message">
        <div className="l-row">
          <div className="p-box__wrap--message">
            <Texts slug={`title/message`} class={'c-text--main c-text--big c-text--en'} />
            <Space size={['64px 0 48px', '48px 0 40px']}>
              <Texts slug={`message/title`} class={''} />
            </Space>
            <Texts slug={`message/body`} class={''} />
          </div>
          
          <Space size={['120px', '80px']}></Space>

          <div className="p-box__wrap--profile">
            <div>
              <Texts slug={`title/profile`} class={'c-text--main c-text--big c-text--en'} />
              <Space size={['64px 0 0', '48px 0 0']}>
                <Texts slug={`profile/cat`} class={'c-text--bold'} />
                <Space size={['24px 0 32px', '24px 0 32px']}>
                  <div className="p-box__wrap--profile__name">
                    <Texts slug={`profile/name`} class={''} />
                    <Texts slug={`profile/name-en`} class={'c-text--en c-text--big'} />
                  </div>
                </Space>
                <Texts slug={`profile/bottom`} class={''} />
              </Space>
            </div>
            <Media src={`common/profile`} alt={'profile'} class={`p-img__profile`} />
          </div>

          <Space size={['160px', '100px']}></Space>
          
          <CompanyList></CompanyList>

          <Space size={['120px', '80px']}></Space>
        </div>
      </div>
      <Space size={['200px', '120px']}></Space>
    </>
  )
};

export default Company;

const CompanyList = () => {
  return(
    <>
      <div className="c-grid__wrap--table">
        <div>
          <Texts slug={`title/company`} class={'c-text--main c-text--big c-text--en'} />
          <Space size={['64px 0 0', '48px 0 0']}>
            <Texts slug={`company/title`} class={''} />
          </Space>
        </div>

        <Table slug="company" len={11}></Table>
      </div>
    </>
  )
}
